import { render, staticRenderFns } from "./OptionPreferences.vue?vue&type=template&id=38a52240&scoped=true"
import script from "./OptionPreferences.vue?vue&type=script&lang=js"
export * from "./OptionPreferences.vue?vue&type=script&lang=js"
import style0 from "./OptionPreferences.vue?vue&type=style&index=0&id=38a52240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a52240",
  null
  
)

export default component.exports